import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import { Button, Table, Modal } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Latex from "react-latex-next";

import CreateEditHintModal from "./CreateEditModal";
import { showErrorNotification, showNotification } from "../../../../../utils/notification";

import "katex/dist/katex.min.css";

const Hint = ({
  isModalOpen = false,
  ROOT_URL,
  taskTitle,
  taskId,
  currentTaskRow = {},
  setTasks = () => {},
  setIsModalOpen = () => {}
}) => {
  const { totalLikes = 0, totalDislikes = 0 } = currentTaskRow;

  const [hints, setHints] = useState([]);
  const [isCreateHintModalOpen, setIsCreateHintModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const handleHintDelete = (hintId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/task/hint/delete`, {
        hintId,
        taskId
      })
      .then((res) => {
        const { updatedHints } = res.data;
        setHints(updatedHints);

        // Update the task with the new hints after closing manage hints modal
        setTasks((prevTasks) => {
          const newTasks = prevTasks.map((task) => {
            if (task._id === taskId) {
              return { ...task, hints: updatedHints };
            }
            return task;
          });
          return newTasks;
        });
        showNotification("Hint deleted Successfully", "Hint deleted Successfully", "success");
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const handleCreateEditHint = (hintParams) => {
    if (initialValues?._id !== undefined) {
      axios
        .put(`${ROOT_URL}/admin/courses/manage/task/hint/edit`, {
          hintParams,
          taskId,
          hintId: initialValues?._id
        })
        .then((res) => {
          const { updatedHints } = res.data;
          setHints(updatedHints);

          // Update the task with the new hints after closing manage hints modal
          setTasks((prevTasks) => {
            const newTasks = prevTasks.map((task) => {
              if (task._id === taskId) {
                return { ...task, hints: updatedHints };
              }
              return task;
            });
            return newTasks;
          });
          setIsCreateHintModalOpen(false);
          showNotification("Hint edited Successfully", "Hint edited Successfully", "success");
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/task/hint/create`, {
          hintParams,
          taskId
        })
        .then((res) => {
          const { updatedHints } = res.data;
          setHints(updatedHints);

          // Update the task with the new hints after closing manage hints modal
          setTasks((prevTasks) => {
            const newTasks = prevTasks.map((task) => {
              if (task._id === taskId) {
                return { ...task, hints: updatedHints };
              }
              return task;
            });
            return newTasks;
          });
          setIsCreateHintModalOpen(false);
          showNotification("Hint created Successfully", "Hint created Successfully", "success");
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (row) => (
        <div>
          <Latex>{row}</Latex>
        </div>
      )
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (updatedAt) => (updatedAt ? dayjs(updatedAt).format("DD MMM YYYY | HH:mm") : "--")
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="section_hints_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            flexWrap: "wrap"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setInitialValues(row);
              setIsCreateHintModalOpen(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleHintDelete(row._id);
            }}
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    setHints(currentTaskRow.hints || []);
  }, [currentTaskRow]);

  return (
    <Modal
      title={taskTitle}
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      style={{ minWidth: "50vw" }}
      width={"auto"}
      onCancel={() => setIsModalOpen(false)}
    >
      <div style={{ marginBottom: "1em" }}>
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateHintModalOpen(true);
          }}
        >
          {" "}
          Create New Hint
        </Button>
      </div>
      <div>
        <b>User Hint feedback is considered if it was marked after the hint was last updated.</b>
      </div>
      <Table
        columns={columns}
        bordered
        pagination={false}
        dataSource={hints}
        scroll={{ x: "max-content" }}
      />
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", margin: "10px 0" }}>
        <div style={{ display: "flex", gap: "5px" }}>
          <LikeOutlined />
          {totalLikes}
        </div>
        <div style={{ display: "flex", gap: "5px" }}>
          <DislikeOutlined />
          {totalDislikes}
        </div>
      </div>
      {isCreateHintModalOpen === true && (
        <CreateEditHintModal
          isModalOpen={isCreateHintModalOpen}
          setIsModalOpen={setIsCreateHintModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?._id !== undefined}
          handleCreateEdit={handleCreateEditHint}
        />
      )}
    </Modal>
  );
};

export default Hint;
